import { FileSpreadsheet } from "lucide-react";
import { useNavigate } from "react-router-dom";
import RecommendationEngineCard from "@/components/admin/RecommendationEngineCard";
import { SettingsBackLink } from "@/components/settings/SettingsBackLink";

export default function RecommendationEngineAdmin() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-background pb-24">
      <div className="px-6 pt-8 pb-6">
        <SettingsBackLink to="/platform/data" label="Data Management" />
        <div className="flex items-center gap-2 mb-1">
          <FileSpreadsheet className="w-5 h-5 text-primary" />
          <h1 className="text-2xl font-bold text-foreground">Recommendation Engine</h1>
        </div>
        <p className="text-muted-foreground">
          Upload and manage the harvest recommendation sheet.
        </p>
      </div>
      <div className="px-6">
        <RecommendationEngineCard />
      </div>
    </div>
  );
}
